import VolunteerNotes from "./notes.jsx";
import * as utils from "./utils.jsx";

import { useBackendData } from "./hooks.ts";

function ContactView({ wp, contact_id }) {
  const data = useBackendData({
    url: `${window.base_url}workparty/${wp._id}/contact/${contact_id}`,
  });

  if (!data) {
    return <div>Loading...</div>;
  }
  const contact = data.contact;
  const my_registrations = data.my_registrations;
  return (
    <section className="layout utility">
      <h1>{contact.website_member_name}</h1>
      <div className="item profile">
        <div className="row">
          <div className="col four">
            {contact.website_member_id ? (
              <img
                className="content"
                src={
                  window.cms_base_url +
                  "/portal_memberdata/portraits/" +
                  contact.website_member_id
                }
                alt="avatar"
              />
            ) : (
              <span>&nbsp;</span>
            )}
            <div style={{ textAlign: "center" }}>
              <h1 style={{ fontSize: "7em", lineHeight: "1em", margin: "0" }}>
                {contact.total_incentive_days}
              </h1>
              <h2>Days Worked</h2>
            </div>
          </div>
          <div className="col eight">
            <h2>{contact.name}</h2>
            <hr />
            <h2>
              <img
                src={
                  window.base_url +
                  "static/svg/" +
                  (contact.vms_permission_level == "Volunteer"
                    ? "helmet-green.svg"
                    : "helmet-orange.svg")
                }
                className="icon"
                style={{ float: "left" }}
              />{" "}
              {contact.vms_permission_level}
            </h2>
            <div className="meta">
              {contact.email ? (
                <h3>
                  <span className="icon-mail-alt"></span>{" "}
                  <a href={"mailto:" + contact.email}>{contact.email}</a>
                </h3>
              ) : (
                ""
              )}
              <div>
                {contact.mailingstreet}
                <br />
                {contact.mailingcity}, {contact.mailingstate}{" "}
                {contact.mailingpostalcode}
                <br />
                {contact.phone
                  ? contact.phone + " (" + contact.phone_type + ")"
                  : ""}
              </div>
            </div>
            {contact.work_party_parent_guardian_1 ? (
              <div>
                <br />
                <h5>Parent/Guardian:</h5>
                <div>
                  {contact.work_party_parent_guardian_1.name}
                  <br />
                  <span className="icon-mail-alt"></span>{" "}
                  <a
                    href={
                      "mailto:" + contact.work_party_parent_guardian_1.email
                    }
                  >
                    {contact.work_party_parent_guardian_1.email}
                  </a>
                  <br />
                  {contact.work_party_parent_guardian_1.phone} (
                  {contact.work_party_parent_guardian_1.phone_type})
                </div>
              </div>
            ) : (
              ""
            )}
            {contact.work_party_parent_guardian_2 ? (
              <div>
                <br />
                <h5>Parent/Guardian:</h5>
                <div>
                  {contact.work_party_parent_guardian_2.name}
                  <br />
                  <span className="icon-mail-alt"></span>{" "}
                  <a
                    href={
                      "mailto:" + contact.work_party_parent_guardian_2.email
                    }
                  >
                    {contact.work_party_parent_guardian_2.email}
                  </a>
                  <br />
                  {contact.work_party_parent_guardian_2.phone} (
                  {contact.work_party_parent_guardian_2.phone_type})
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        {contact.certifications.length ? (
          <div>
            <hr />
            <h5>Certifications</h5>
            <table>
              <tr>
                <th>Certification</th>
                <th>Status</th>
                <th>Process Status</th>
                <th>Dates Valid</th>
              </tr>
              {contact.certifications.map((c) => (
                <tr>
                  <td>
                    <h5>{c.certification.name}</h5>
                  </td>
                  <td>{c.active_status}</td>
                  <td>{c.status}</td>
                  <td>
                    <utils.DateRange
                      start={c.start_date}
                      end={c.end_date}
                      showTime={false}
                    />
                  </td>
                </tr>
              ))}
            </table>
          </div>
        ) : (
          ""
        )}
        {contact.awards.length ? (
          <div>
            <hr />
            <h5>Awards</h5>
            <table>
              <tr>
                <th colSpan={2}>Award</th>
                <th>Award Status</th>
                <th>Award Distributed Date</th>
                <th>Award Distributed Work Party</th>
              </tr>
              {contact.awards.map((a) => (
                <tr>
                  <td>
                    <img src={a.award.image_url} />
                  </td>
                  <td>
                    <h5>{a.award.name}</h5>
                  </td>
                  <td>{a.status}</td>
                  <td>
                    {a.wp_start_date ? (
                      <utils.DateRange
                        start={a.wp_start_date}
                        showTime={false}
                      />
                    ) : (
                      ""
                    )}
                  </td>
                  <td>{a.work_party_name}</td>
                </tr>
              ))}
            </table>
          </div>
        ) : (
          ""
        )}
        {contact.wp_registrations ? (
          <div>
            <hr />
            <h5>Recent Work Party History</h5>
            <table>
              <tr>
                <th>Work Party</th>
                <th>Date</th>
                <th></th>
              </tr>
              {contact.wp_registrations.map((r) => {
                var my_registration = my_registrations[r.work_party._id];
                return (
                  <tr>
                    <td>{r.work_party.name}</td>
                    <td>
                      <utils.DateRange
                        start={r.work_party.start_date_time}
                        end={r.work_party.end_date_time}
                      />
                    </td>
                    <td>
                      {my_registration !== undefined &&
                      my_registration.status == "Registered" ? (
                        <span className="icon-user">Worked with you</span>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        ) : (
          ""
        )}
        <hr />
        <VolunteerNotes wp={wp} contact={contact} />
      </div>
    </section>
  );
}

export default ContactView;
